// Forces only the first letter of each word uppercase, per the design ask - it deliberately
// leaves the rest of each word untouched (not full title-casing), matching what a mobile
// keyboard's autocapitalize="words" hint does, so typing "jOHN sMITH" yields "JOHN SMITH", not
// "John Smith".
function matcherCapitalizeName(fullName: string): string {
  return fullName.replace(/\b\w/g, (char) => char.toUpperCase());
}

export { matcherCapitalizeName };
